import { Step, Stepper, StepLabel } from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 14,
    [theme.breakpoints.up("sm")]: {
      top: 17,
    },
    [theme.breakpoints.up("md")]: {
      top: 20,
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(95deg, rgb(34, 193, 94) 0%, rgb(0, 128, 0) 50%, rgb(0, 100, 0) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(95deg, rgb(34, 193, 94) 0%, rgb(0, 128, 0) 50%, rgb(0, 100, 0) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  padding: "4px",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    padding: "5px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "7px",
  },
  "& svg": {
    fontSize: "0.75rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.95rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.25rem",
    },
  },
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(136deg, rgb(34, 193, 94) 0%, rgb(0, 128, 0) 50%, rgb(0, 100, 0) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(136deg, rgb(34, 193, 94) 0%, rgb(0, 128, 0) 50%, rgb(0, 100, 0) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icon}
    </ColorlibStepIconRoot>
  );
}

const CustomStepper = ({ steps, completedStep, activeStep }) => {
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep - 1}
      connector={<ColorlibConnector />}
      sx={{
        width: "100%",
        "& .MuiStepLabel-label": {
          fontSize: {
            xs: "0.5rem",
            sm: "0.65rem",
            md: "0.8rem",
          },
          mt: { xs: "2px", sm: "4px", md: "6px" },
        },
        "& .MuiStep-root": {
          px: { xs: 0.3, sm: 1, md: 1 },
        },
      }}
    >
      {steps.map((step) => (
        <Step key={step.label}>
          <StepLabel
            StepIconComponent={() => (
              <ColorlibStepIcon
                active={completedStep == step.completedStep}
                completed={step.statusId <= completedStep}
                icon={step.icon}
              />
            )}
          >
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CustomStepper;
